import { Fields } from 'common/form';
import { ConversationSettingsFormData } from './conversationSettingsSchema';
import { AGENT_TONE_OPTIONS } from 'modules/agents/constants';

export const getConversationSettingsFields =
  (): Fields<ConversationSettingsFormData> => {
    return {
      successfulMessage: {
        type: 'textarea',
        label: 'Successful candidates',
        subLabel: `When all knockout questions (if added) are satisfied, and the conversation completes. You can add links (URL) or phone numbers into this message.`,
        rows: 5
      },
      unsuccessfulMessage: {
        type: 'textarea',
        label: 'Unsuccessful candidates',
        subLabel:
          'When the candidate is knocked out, or does not complete the conversation.',
        rows: 8
      },
      notInterestedMessage: {
        type: 'textarea',
        label: 'Candidates who are not interested',
        rows: 8
      },
      agentName: {
        type: 'text',
        label: 'Virtual agent name',
        group: 'agentSettings'
      },
      agentTone: {
        type: 'radio',
        label: 'Conversational tone',
        group: 'agentSettings',
        options: AGENT_TONE_OPTIONS
      }
    };
  };
